import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {MvsCrudService} from "features/core/shared/service/crud/mvs-crud.service";
import {HelpGlossaryTermDto} from "../../model/dto/help-glossary.dto";

@Injectable({
    providedIn: 'root'
})
export class HelpGlossaryService {

    private readonly apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = MvsCrudService.baseUrl + '/cb/help/glossary';
    }

    getTerms(moduleAlias: string): Observable<HelpGlossaryTermDto[]> {
        return this.http.get<HelpGlossaryTermDto[]>(this.apiUrl, {
            params: new HttpParams().set('moduleAlias', moduleAlias)
        });
    }

    getTerm(id: number): Observable<HelpGlossaryTermDto> {
        return this.http.get<HelpGlossaryTermDto>(`${this.apiUrl}/${id}`);
    }

    searchTerms(query: string, moduleAlias?: string): Observable<HelpGlossaryTermDto[]> {
        let params = new HttpParams().set('q', query);
        if (moduleAlias) {
            params = params.set('moduleAlias', moduleAlias);
        }
        return this.http.get<HelpGlossaryTermDto[]>(`${this.apiUrl}/search`, {params});
    }

    createTerm(term: Partial<HelpGlossaryTermDto>): Observable<HelpGlossaryTermDto> {
        return this.http.post<HelpGlossaryTermDto>(this.apiUrl, term);
    }

    updateTerm(id: number, term: Partial<HelpGlossaryTermDto>): Observable<HelpGlossaryTermDto> {
        return this.http.put<HelpGlossaryTermDto>(`${this.apiUrl}/${id}`, term);
    }

    deleteTerm(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
